import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
}                                from '@angular/core';
import {
  FormControl,
  Validators,
}                                from '@angular/forms';
import { FileExtension }         from '~domain/enums';
import { DocumentService }       from '../document.service';
import { RenameDocumentService } from '../rename-document/rename-document.service';

@Component({
  selector: 'rb-document-name-bar',
  templateUrl: './document-name-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DocumentNameBarComponent implements OnChanges {
  @Input({ required: true }) documentId!: string;
  @Input() clientId?: string;
  @Input({ required: true }) name!: string;
  @Input({ required: true }) extension!: FileExtension;
  @Input() downloadEnabled = true;
  @Output() renamingChange = new EventEmitter<boolean>();

  renaming = false;
  currentName = '';
  renameDocumentIsLoading$ = this.renameDocumentService.renameDocumentIsLoading$;
  documentDownloadId$ = this.documentService.documentDownloadingId$;
  control = new FormControl('', {
    nonNullable: true,
    validators: [
      Validators.required,
      control => control.value.trim() ? null : { whitespace: true },
    ],
  });

  constructor(
    private readonly documentService: DocumentService,
    private readonly renameDocumentService: RenameDocumentService,
  ) {
  }

  get fullName() {
    return `${this.currentName}.${this.extension}`;
  }

  get trimmedValue() {
    return this.control.value.trim();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['name'] && !this.renaming) {
      this.currentName = this.name ?? '';
      this.control.setValue(this.currentName, { emitEvent: false });
    }
  }

  startRenaming() {
    this.control.setValue(this.currentName, { emitEvent: false });
    this.renaming = true;
    this.renamingChange.emit(true);
  }

  cancelRenaming() {
    this.control.setValue(this.currentName, { emitEvent: false });
    this.renaming = false;
    this.renamingChange.emit(false);
  }

  confirmRename() {
    const name = this.trimmedValue;
    if (this.control.invalid || !this.documentId) {
      this.control.markAsTouched();
      return;
    }
    this.currentName = name;
    this.renaming = false;
    this.renamingChange.emit(false);
    this.renameDocumentService.renameDocument(name, this.documentId, this.clientId, {
      closeDialog: false,
      reload: false,
    });
  }

  confirmRenameOnEnter(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.confirmRename();
  }

  downloadDocument() {
    if (!this.documentId || !this.currentName || !this.extension) {
      return;
    }
    this.documentService.downloadDocument(this.currentName, this.extension, this.documentId, this.clientId);
  }
}
